import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, styled, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import "./index.css"
import { DefaultArrayEmpty } from "utilities/utilities";
import { BtnDelete, BtnEditData } from "components/Button/ButtonAll";
import HTMLReactParser from "html-react-parser";
import CustomTablePagination from "view/Backend/IncomeExpenses/Ticket/components/CustomTablePagination";

export default function TableEmployee(props) {

    const { sColumnName, sColumnDate, data, onDelete, IsHeadAction, onEdit, nEditID } = props;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [dataTable, setdataTable] = useState([]);
    const [selected, setSelected] = useState<readonly number[]>([]);

    useEffect(() => {
        setdataTable(data)
    }, [data])

    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event?.target?.checked) {
            const newSelected = dataTable.map((n) => n.nID);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(even)': {
            backgroundColor: theme.palette.action.hover,
        }
    }));

    return (
        <>
            <TableContainer id='table-standard' component={Paper}>
                <Table sx={{ minWidth: 500 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" style={{ minWidth: '100px', width: '10%' }}></TableCell>
                            <TableCell align="center" style={{ minWidth: '100px', width: '10%' }}>ที่</TableCell>
                            <TableCell align="center" style={{ minWidth: '120px', width: '50%' }}>{sColumnName}</TableCell>
                            <TableCell align="center" style={{ minWidth: '120px', width: '30%' }}>{sColumnDate}</TableCell>
                        </TableRow>
                    </TableHead>
                    {
                        dataTable.length > 0 ?
                            <TableBody>
                                {(dataTable.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)).map((row, index) => {
                                    let nNo = (page * rowsPerPage) + (index + 1);
                                    return (
                                        <>
                                            {row.IsHead ?
                                                <>
                                                    <StyledTableRow key={nNo}>
                                                        {IsHeadAction &&
                                                            <TableCell align="center" style={{ background: "#EADDCA" }}>
                                                                <Grid container spacing={1}>
                                                                    <Grid item xs={6}>
                                                                        <BtnDelete
                                                                            id="EditDelete"
                                                                            IsCircleWithOutText
                                                                            onClick={() => onDelete(row.nID)}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={6}>
                                                                        <BtnEditData
                                                                            id="EditGoal"
                                                                            IsCircleWithOutText
                                                                            bgcolor="#F6C000"
                                                                            bgcolorHover="#F6C000"
                                                                            onClick={() => onEdit(row.nID)}
                                                                            IsDisabled={nEditID === row.nID}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </TableCell>
                                                        }
                                                        <TableCell colSpan={3} style={{ background: "#EADDCA" }}>
                                                            <b>เรื่อง : </b>{HTMLReactParser(row.sTopic)}
                                                        </TableCell>
                                                    </StyledTableRow>

                                                    {row.lstChildren &&
                                                        DefaultArrayEmpty(row.lstChildren).map((cRow, cIndex) => {
                                                            let nNo = (page * rowsPerPage) + (cIndex + 1);
                                                            return (
                                                                <StyledTableRow key={"child_" + nNo}>
                                                                    {!IsHeadAction ?
                                                                        <TableCell align="center" >
                                                                            <Grid container spacing={1}>
                                                                                <Grid item xs={6}>
                                                                                    <BtnDelete
                                                                                        id="EditDelete"
                                                                                        IsCircleWithOutText
                                                                                        onClick={() => onDelete(cRow.nID)}
                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={6}>
                                                                                    <BtnEditData
                                                                                        id="EditGoal"
                                                                                        IsCircleWithOutText
                                                                                        bgcolor="#F6C000"
                                                                                        bgcolorHover="#F6C000"
                                                                                        onClick={() => onEdit(cRow.nID)}
                                                                                        IsDisabled={nEditID === cRow.nID}
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>
                                                                        </TableCell>
                                                                        :
                                                                        <TableCell align="center" ></TableCell>
                                                                    }
                                                                    <TableCell align="center" >
                                                                        {cRow.nOrder}
                                                                    </TableCell>
                                                                    <TableCell align="left" >
                                                                        {cRow.sName}
                                                                    </TableCell>
                                                                    <TableCell align="center" >
                                                                        {cRow.sDate}
                                                                    </TableCell>
                                                                </StyledTableRow>
                                                            )
                                                        })
                                                    }
                                                </>
                                                :
                                                <StyledTableRow key={nNo}>
                                                    <TableCell align="center" >
                                                        <Grid container spacing={1}>
                                                            <Grid item xs={6}>
                                                                <BtnDelete
                                                                    id="EditDelete"
                                                                    IsCircleWithOutText
                                                                    onClick={() => onDelete(row.nID)}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <BtnEditData
                                                                    id="EditGoal"
                                                                    IsCircleWithOutText
                                                                    bgcolor="#F6C000"
                                                                    bgcolorHover="#F6C000"
                                                                    onClick={() => onEdit(row.nID)}
                                                                    IsDisabled={nEditID === row.nID}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align="center" >
                                                        {row.nOrder}
                                                    </TableCell>
                                                    <TableCell align="left" >
                                                        {row.sName}
                                                    </TableCell>
                                                    <TableCell align="center" >
                                                        {row.sDate}
                                                    </TableCell>
                                                </StyledTableRow>
                                            }
                                        </>
                                    )
                                })}
                            </TableBody>
                            :
                            <TableRow key={"r-no-data"} >
                                <TableCell align="center" colSpan={4}>ไม่พบข้อมูล</TableCell>
                            </TableRow>
                    }
                </Table>
            </TableContainer>
            <CustomTablePagination
                dataTable={dataTable}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                page={page}
                setPage={setPage}
                colSpan={4}
                selection={selected}
                onDelete={onDelete}
                handleSelectAllClick={handleSelectAllClick}
            />
        </>
    )
}